<a class="icon-primary-btn" href="javascript:void(0)" (click)="openHelpfulLink()">
	<i class="icomoon nxticon-help"></i>
</a>

								<!-- <a href="javascript:void(0)"  (click)="openHelpfulLink()"
 class="font-bold helpful-link"><i class="fa fa-question-circle font-medium mr-2"
></i>Helpful Link</a> -->
<!--bootstrap modal for showing twofa info popup-->
<ng-template #helpSection let-c="close" let-d="dismiss">
    <div class="modal-header">
		<h4 class="font-large">Helpful Links
    		<button type="button" class="close-btn" aria-label="Close" (click)="d('Cross click')">
      			<span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span> 
    		</button>
    	</h4>
	</div>
    <div class="modal-body">
  		<ul class="list-unstyled link-group" *ngFor="let helpdata of helpFulData">
			<li class="mb-4"><a class="text-link blue" href="{{helpdata.helpLink}}" target="_blank">{{helpdata.helpText}}</a>
       		</li>
  		</ul>
    </div>
</ng-template>

